import React, { useRef, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { App, Button, Input, Popconfirm, Popover, Space } from 'antd';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  MdDelete,
  MdModeEditOutline,
  MdOutlineViewColumn,
  MdRemoveRedEye,
  MdViewColumn,
} from 'react-icons/md';
import { getGeneralLedger } from '../../network/generalLedger';
import { ModalAppGeneralLedger } from '../../components/upeosoft/ModalApp/ModalApp';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { colorPrimary } from '../../utils/utils';

const GeneralLedgerTable = ({ t }) => {
  const searchInput = useRef(null);
  const [searchTextValue, setSearchTextValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const { currentLang } = useSelector((state) => state.user);
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm, setSelectedKeys) => {
    confirm();
    clearFilters();
    setSearchText('');
    setSelectedKeys(['']);
    setSearchTextValue('');
  };
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getGeneralLedger, searchText],
    queryFn: () => getGeneralLedger(searchText),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر',
      dataIndex: 'posting_date',
    },
    {
      title: currentLang === 'en' ? 'Account' : 'حساب',
      dataIndex: 'account',
    },
    {
      title: currentLang === 'en' ? 'Debit(SAR)' : 'دائن (ريال سعودي)',
      dataIndex: 'debit',
    },
    {
      title: currentLang === 'en' ? 'Credit(SAR)' : 'مدين (ريال سعودي)',
      dataIndex: 'credit',
    },
    {
      title: currentLang === 'en' ? 'Balance(SAR)' : 'الرصيد (ريال سعودي)',
      dataIndex: 'balance',
    },
    {
      title: currentLang === 'en' ? 'Voucher Type' : 'نوع القسيمة',
      dataIndex: 'voucher_type',
    },
    {
      title: currentLang === 'en' ? 'Voucher No' : 'رقم القسيمة',
      dataIndex: 'voucher_no',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={t.search}
            value={searchTextValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setSearchTextValue(e.target.value);
              // setSearchText(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm)}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              // onClick={() => confirm()}
              onClick={() => handleSearch(selectedKeys, confirm)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() =>
                clearFilters &&
                handleReset(clearFilters, confirm, setSelectedKeys)
              }
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          // setSearchText("");
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: currentLang === 'en' ? 'Against Account' : 'ضد الحساب',
      dataIndex: 'against_account',
    },
    {
      title: currentLang === 'en' ? 'Party Type' : 'نوع الحزب',
      dataIndex: 'party_type',
    },
    {
      title: currentLang === 'en' ? 'Party' : 'الحزب',
      dataIndex: 'party',
    },
    {
      title: currentLang === 'en' ? 'Project' : 'المشروع',
      dataIndex: 'project',
    },
    {
      title: currentLang === 'en' ? 'Cost Center' : 'مركز التكلفة',
      dataIndex: 'cost_center',
    },
    {
      title: currentLang === 'en' ? 'Against Voucher Type' : 'ضد نوع القسيمة',
      dataIndex: 'against_voucher_type',
    },
    {
      title: currentLang === 'en' ? 'Against Voucher' : 'ضد القسيمة',
      dataIndex: 'against_voucher',
    },
    {
      title: currentLang === 'en' ? 'Supplier Invoice No' : 'رقم فاتورة المورد',
      dataIndex: 'supplier_invoice',
    },
    {
      title: currentLang === 'en' ? 'Remarks' : 'ملاحظات',
      dataIndex: 'remarks',
      ellipsis: true,
      render: (text) => (
        <div>{text.length > 50 ? text.slice(0, 50) + '...' : text} </div>
      ),
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record.id);
                setEdit(true);
                setOpen(true);
              }}
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover> */}
            <Button
              size="small"
              type="primary"
              // onClick={() => navigate(`/patients/${record.uid}`)}
            >
              <MdRemoveRedEye />
            </Button>
            <Popconfirm
              title={t.DeletetheGeneralLedger}
              description={t.areYouSure}
              //   onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const dataTable = data?.message?.gl_entries?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });

  return (
    <div className="general-ledger">
      <Heading title={t.Finance} subTitle={t.generalLedger} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        searchInput={true}
        // titleBtn={t.addJournalEntry}
        // Placeholder={t.}
      />
      <ModalAppGeneralLedger
        t={t}
        open={open}
        setOpen={setOpen}
        record={editId}
        edit={edit}
      />
    </div>
  );
};

export default GeneralLedgerTable;
